import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Devices from './pages/Devices';
import Groups from './pages/Groups';
import Users from './pages/Users';
import AuditLogs from './pages/AuditLogs';
import Download from './pages/Download';
import DeviceHistory from './pages/DeviceHistory';
import Layout from './components/Layout';

const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  const token = localStorage.getItem('token');
  return token ? <>{children}</> : <Navigate to="/login" />;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Navigate to="/login" />} />
        <Route path="/" element={<PrivateRoute><Layout><Dashboard /></Layout></PrivateRoute>} />
        <Route path="/devices" element={<PrivateRoute><Layout><Devices /></Layout></PrivateRoute>} />
        <Route path="/devices/:id/history" element={<PrivateRoute><Layout><DeviceHistory /></Layout></PrivateRoute>} />
        <Route path="/groups" element={<PrivateRoute><Layout><Groups /></Layout></PrivateRoute>} />
        <Route path="/users" element={<PrivateRoute><Layout><Users /></Layout></PrivateRoute>} />
        <Route path="/audit" element={<PrivateRoute><Layout><AuditLogs /></Layout></PrivateRoute>} />
        <Route path="/download" element={<PrivateRoute><Layout><Download /></Layout></PrivateRoute>} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
